import { render, staticRenderFns } from "./selectGender.vue?vue&type=template&id=5ca71a7a&"
import script from "./selectGender.vue?vue&type=script&lang=ts&"
export * from "./selectGender.vue?vue&type=script&lang=ts&"
import style0 from "./selectGender.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports